export const controls = {
  colors: {
    options: [
      '--gray-0',
      '--gray-1',
      '--gray-2',
      '--gray-3',
      '--gray-4',
      '--gray-5',
      '--gray-6',
      '--gray-7',
      '--gray-8',
      '--gray-9',
      '--red-0',
      '--red-1',
      '--red-2',
      '--red-3',
      '--red-4',
      '--red-5',
      '--red-6',
      '--red-7',
      '--red-8',
      '--red-9',
      '--pink-0',
      '--pink-1',
      '--pink-2',
      '--pink-3',
      '--pink-4',
      '--pink-5',
      '--pink-6',
      '--pink-7',
      '--pink-8',
      '--pink-9',
      '--grape-0',
      '--grape-1',
      '--grape-2',
      '--grape-3',
      '--grape-4',
      '--grape-5',
      '--grape-6',
      '--grape-7',
      '--grape-8',
      '--grape-9',
      '--violet-0',
      '--violet-1',
      '--violet-2',
      '--violet-3',
      '--violet-4',
      '--violet-5',
      '--violet-6',
      '--violet-7',
      '--violet-8',
      '--violet-9',
      '--indigo-0',
      '--indigo-1',
      '--indigo-2',
      '--indigo-3',
      '--indigo-4',
      '--indigo-5',
      '--indigo-6',
      '--indigo-7',
      '--indigo-8',
      '--indigo-9',
      '--blue-0',
      '--blue-1',
      '--blue-2',
      '--blue-3',
      '--blue-4',
      '--blue-5',
      '--blue-6',
      '--blue-7',
      '--blue-8',
      '--blue-9',
      '--cyan-0',
      '--cyan-1',
      '--cyan-2',
      '--cyan-3',
      '--cyan-4',
      '--cyan-5',
      '--cyan-6',
      '--cyan-7',
      '--cyan-8',
      '--cyan-9',
      '--teal-0',
      '--teal-1',
      '--teal-2',
      '--teal-3',
      '--teal-4',
      '--teal-5',
      '--teal-6',
      '--teal-7',
      '--teal-8',
      '--teal-9',
      '--green-0',
      '--green-1',
      '--green-2',
      '--green-3',
      '--green-4',
      '--green-5',
      '--green-6',
      '--green-7',
      '--green-8',
      '--green-9',
      '--lime-0',
      '--lime-1',
      '--lime-2',
      '--lime-3',
      '--lime-4',
      '--lime-5',
      '--lime-6',
      '--lime-7',
      '--lime-8',
      '--lime-9',
      '--yellow-0',
      '--yellow-1',
      '--yellow-2',
      '--yellow-3',
      '--yellow-4',
      '--yellow-5',
      '--yellow-6',
      '--yellow-7',
      '--yellow-8',
      '--yellow-9',
      '--orange-0',
      '--orange-1',
      '--orange-2',
      '--orange-3',
      '--orange-4',
      '--orange-5',
      '--orange-6',
      '--orange-7',
      '--orange-8',
      '--orange-9',
    ],
    control: { type: 'select' },
    description: 'Open Props color values. Can also use any valid color value.',
    table: {
      category: 'css variables',
    },
  },
  gradients: {
    options: [
      '--gradient-0',
      '--gradient-1',
      '--gradient-2',
      '--gradient-3',
      '--gradient-4',
      '--gradient-5',
      '--gradient-6',
      '--gradient-7',
      '--gradient-8',
      '--gradient-9',
      '--gradient-10',
      '--gradient-11',
      '--gradient-12',
      '--gradient-13',
      '--gradient-14',
      '--gradient-15',
      '--gradient-16',
      '--gradient-17',
      '--gradient-18',
      '--gradient-19',
      '--gradient-20',
      '--gradient-21',
      '--gradient-22',
      '--gradient-23',
      '--gradient-24',
      '--gradient-25',
      '--gradient-26',
      '--gradient-27',
      '--gradient-28',
      '--gradient-29',
      '--gradient-30',
    ],
    control: { type: 'select' },
    description: 'Open Props gradients',
    table: {
      category: 'css variables',
    },
  },
  shadows: {
    options: [
      '--shadow-1',
      '--shadow-2',
      '--shadow-3',
      '--shadow-4',
      '--shadow-5',
      '--shadow-6',
      '--inner-shadow-0',
      '--inner-shadow-1',
      '--inner-shadow-2',
      '--inner-shadow-3',
      '--inner-shadow-4',
    ],
    control: { type: 'select' },
    description: 'Open props shadow values',
    table: {
      category: 'css variables',
    },
  },
  fontFamily: {
    options: ['--font-sans', '--font-serif', '--font-mono'],
    control: { type: 'select' },
    description: 'Open Props font families',
    table: {
      category: 'css variables',
    },
  },
  fontLineheight: {
    options: [
      '--font-lineheight-00',
      '--font-lineheight-0',
      '--font-lineheight-1',
      '--font-lineheight-2',
      '--font-lineheight-3',
      '--font-lineheight-4',
      '--font-lineheight-5',
    ],
    control: { type: 'select' },
    description: 'Open Props line heights',
    table: {
      category: 'css variables',
    },
  },
  aspectRatio: {
    options: [
      'square',
      'landscape',
      'portrait',
      'widescreen',
      'ultrawide',
      'golden',
    ],
    control: { type: 'select' },
    description: 'Open Props aspect-ratios',
    table: {
      category: 'css variables',
    },
  },
  rel: {
    options: [
      'alternate',
      'author',
      'bookmark',
      'external',
      'help',
      'license',
      'next',
      'nofollow',
      'noopener',
      'noreferrer',
      'prev',
      'search',
      'tag',
    ],
    control: { type: 'select' },
    description: 'Link rel values',
    table: {
      category: 'properties',
    },
  },
  target: {
    options: ['_blank', '_self', '_parent', '_top'],
    control: { type: 'select' },
    description: 'Link target values',
    table: {
      category: 'properties',
    },
  },

  sizes: {
    options: [
      '--size-1',
      '--size-2',
      '--size-3',
      '--size-4',
      '--size-5',
      '--size-6',
      '--size-7',
      '--size-8',
      '--size-9',
      '--size-10',
      '--size-11',
      '--size-12',
      '--size-13',
      '--size-14',
      '--size-15',
    ],
    control: { type: 'select' },
    description: 'Open Props relative sizes',
    table: {
      category: 'css variables',
    },
  },
  radii: {
    options: [
      '--radius-1',
      '--radius-2',
      '--radius-3',
      '--radius-4',
      '--radius-5',
      '--radius-6',
    ],
    control: { type: 'select' },
    description: 'Open Props border radius values',
    table: {
      category: 'css variables',
    },
  },
  headingLevels: {
    options: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    control: { type: 'select' },
    description: 'Heading level values',
    table: {
      category: 'properties',
    },
  },

  border: {
    description:
      'CSS border value. Can contain variables. Ex: var(--border-size-5) solid var(--orange-4)',
    control: { type: 'text' },
    table: {
      category: 'css variables',
    },
  },
};

export const themeControls = {
  gdwcFontFamily: controls.fontFamily,
  gdwcFontLineheight: controls.fontLineheight,
  gdwcText1: controls.colors,
  gdwcText2: controls.colors,
  gdwcLink: controls.colors,
  gdwcLinkVisited: controls.colors,
  gdwcBgLight: controls.colors,
  gdwcBgDark: controls.colors,
  gdwcSurface1: controls.colors,
  gdwcPadding: controls.sizes,
  gdwcBorderRadius: controls.radii,
  gdwcBorder: controls.border,
  gdwcBorderColor: controls.colors,
  gdwcBackgroundGradient: controls.gradients,
  gdwcShadow: controls.shadows,
  gdwcHighlightLight: controls.colors,
  gdwcHighlightDark: controls.colors,
  gdwcInkShadowColorLight: controls.colors,
  gdwcInkShadowColorDark: controls.colors,
};
